import { actionCreatorFactory } from 'typescript-fsa';
import { ApiFieldError } from 'src/types';

type APIError = ApiFieldError;

/**
 * Action Creators
 */
export const actionCreator = actionCreatorFactory(`@@LENDSMARTMANAGER/LOANAPP`);

export const setLoanAppInStore = actionCreator<any>(
  'update-single-loanapp'
);

export type UpdateLoanAppParams = any;

export const updateLoanAppActions = actionCreator.async<
UpdateLoanAppParams,
  any,
  APIError[]
>(`loanapp-update`);


export const loanApplicationRequest = actionCreator<string>('request');
export const update = actionCreator<any>('update');

export const loanApplicationRequestSuccess = actionCreator<any>('success');

export const loanApplicationRequestStart = actionCreator('loanapp-request');

export const loanApplicationRequestSuccessById =
  actionCreator<any>('loanapp-success');

export const loanApplicationRequestFailById =
  actionCreator<string>('loanapp-fail');

export const loanApplicationRequestFail = actionCreator<APIError[]>('fail');
